module.exports = __webpack_public_path__ + "static/media/table.c5461eb2.pdf";